// @flow
import React, { useState } from 'react';

type Props = {
  children: Object | Object[],
  onClick: Function,
  className: string
}

const Button = (props: Props) => {
  const {
    children, onClick, className
  } = props;

  // Track dropdown state for button icon
  const [isOpen, setIsOpen] = useState(false);

  const open = (e) => {
    onClick(e);

    // Button click can open or close the dropdown
    setIsOpen(!isOpen);
  };

  return (
    <div>
      <button
        type="button"
        className={className}
        onClick={open}
      >{children}
      </button>
      <i
        className="material-icons"
        style={{
          position: 'absolute',
          transition: 'all .3s ease',
          transform: isOpen ? 'rotate(-180deg)' : 'none'
        }}
      >keyboard_arrow_down
      </i>
    </div>
  );
};

export default Button;
